import { OverlayPanel } from 'primereact/overlaypanel';
import { FC, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export enum InfoType {
  EXIT_SLIP,
  DAILY,
  WEEKLY,
}
interface Props {
  infoType: InfoType;
}
const TeacherDashboardInfoIcon: FC<Props> = ({ infoType }) => {
  const op = useRef<OverlayPanel>(null);
  const [contentRender, setContentRender] = useState<JSX.Element | null>(null);
  const [isActive, setIsActive] = useState<boolean>(false);

  useEffect(() => {
    if (infoType === InfoType.DAILY) {
      setContentRender(
        <>
          <div>
            <h3>Track today’s skill results</h3>
            <span className="pi pi-times cursor-pointer" onClick={() => op.current?.hide()} />
          </div>
          <p className="px-3 mb-0">Today’s Skill Challenge Progress — See how students are doing on today’s skill.</p>
          <p className="px-3 mb-0">
            Click a band to see who’s in each range and copy the list of students you want to follow up with.
          </p>
          <p className="font-bold px-3 py-1">Ideal for Foundations teachers and monitoring on RTI days.</p>
        </>,
      );
    }
    if (infoType === InfoType.EXIT_SLIP) {
      setContentRender(
        <>
          <div>
            <h3>About Exit Tickets</h3>
            <span className="pi pi-times cursor-pointer" onClick={() => op.current?.hide()} />
          </div>
          <h6 className="font-bold px-3 pt-1 tw-font-['Arial'] text-base">Review exit ticket results</h6>
          <h6 className="font-normal px-3 py-2">Designed for core teachers to...</h6>
          <ul className="px-3 pb-2 pt-0 my-0">
            <li className="mx-4">
              See how well students understood today’s lesson and take a closer look at individual results.
            </li>
            <li className="mx-4 font-bold">Check results for past days using the date picker or lesson search bar</li>
          </ul>
          <p className="px-3 py-2 mt-0 mb-1">
            <span className="font-italic">No upcoming tickets?</span> Click “
            <span className="font-semibold">Assign More</span>” to schedule new exit tickets.{' '}
          </p>
          <p className="mx-3 pt-2 mb-1 mt-0 border-top-1 border-400 font-semibold text-base tw-font-['Arial']">
            Color Key
          </p>
          <p className="mx-3 py-0 mt-1 font-normal text-sm">
            <span className="font-bold">Green:</span> Correct <br></br>
            <span className="font-bold">Red:</span> Incorrect <br></br>
            <span className="font-bold">Gray:</span> Not answered/skipped <br></br>
          </p>
        </>,
      );
    }
    if (infoType === InfoType.WEEKLY) {
      setContentRender(
        <>
          <div>
            <h3>Track progress towards Skill Goals</h3>
            <span className="pi pi-times cursor-pointer" onClick={() => op.current?.hide()} />
          </div>
          <p className="px-3 py-2">
            Use this view to check if students are keeping up with homework. If you’ve assigned specific skills, head to
            the{' '}
            <Link className="font-semibold" to={'/assignments'} target="_blank">
              Assignments tab
            </Link>{' '}
            for more detail.
          </p>
          {/* Hide until link will be available */}
          {/* <p className="mx-3 pt-2 mb-1 mt-0 pt-3 border-top-1 border-400 font-semibold">Weekly goal: 2 new skills</p>
          <p className="px-3 pb-2 my-0">
            Our studies show that students who meet this goal each week make huge strides towards state test
            proficiency. <a className="font-semibold">Learn more</a>
          </p>
          <p className="px-3 pb-2">Each week is evaluated independently.</p> */}
        </>,
      );
    }
  }, [infoType]);

  return (
    <>
      <div
        className={`nc_teacher-dashboard-info tw-py-2 tw-h-min ${isActive ? 'active' : ''}`}
        onClick={e => op.current?.toggle(e)}
      >
        <span className="nc_teacher-dashboard-info-text">
          {infoType !== InfoType.EXIT_SLIP ? 'How to use this?' : 'About'}
        </span>
        {infoType === InfoType.EXIT_SLIP && (
          <p className="tw-text-blue-500 tw-font-atkinson tw-text-base tw-font-bold tw-m-0">About</p>
        )}
        <span className="pi pi-info-circle nc_teacher-dashboard-info-icon"></span>
      </div>
      <OverlayPanel
        ref={op}
        style={{ width: '320px' }}
        className="!tw-z-[2] nc_teacher-dashboard-op"
        onShow={() => setIsActive(true)}
        onHide={() => setIsActive(false)}
      >
        <div className="nc_teacher-dashboard-op-container">{contentRender}</div>
      </OverlayPanel>
    </>
  );
};

export default TeacherDashboardInfoIcon;
